export const getFeCroppedImage = (src: string, maxWidth = 450): string => {
    if (!src) return ''
    if (src.includes('?')) return src
    else return src + '?mode=min&width=' + maxWidth
}
